import React from 'react';
import { Row, Col, Card, CardBody, Container } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/white logo png.png';

const PendingApproval = () => {
    document.title = "Pending Approval | Arcmedix";
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('authUser');
        navigate('/login');
    };

    return (
        <div className="authentication-bg min-vh-100">
            <div className="bg-overlay"></div>
            <Container>
                <div className="d-flex flex-column min-vh-100 px-3">
                    <Row className="justify-content-center my-auto">
                        <Col md={8} lg={6} xl={5}>
                            <div className="text-center mb-4">
                                <img src={logo} alt="" height="90" width="200" />
                            </div>
                            <Card>
                                <CardBody className="p-5 text-center">
                                    <div className="mb-4">
                                        <i className="bx bx-time-five text-warning" style={{ fontSize: '4rem' }}></i>
                                    </div>
                                    <h4 className="text-primary mb-3">Pending Approval</h4>
                                    <p className="text-muted mb-4">
                                        Your organization is pending approval. We'll notify you by email
                                        once your organization has been reviewed and approved.
                                    </p>
                                    <p className="text-muted small mb-4">
                                        This process typically takes 1-2 business days.
                                    </p>
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={handleLogout}
                                    >
                                        Logout
                                    </button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center text-muted p-4">
                                <p className="text-white-50">
                                    Copyright &copy; {new Date().getFullYear()} Arcmedix. All rights reserved
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    );
};

export default PendingApproval;
